import { render, staticRenderFns } from "./HeaderAndFooter.vue?vue&type=template&id=7fbb822a"
import script from "./HeaderAndFooter.vue?vue&type=script&lang=js"
export * from "./HeaderAndFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports